import React, { useState, useEffect } from "react";
import Slider from "../components/sidebar";
import { useParams, useNavigate } from "react-router-dom";
import { insertOfferPost } from "../services/offerpost";
import ErrorModal from "../components/error";
import { ImagePathRoutes } from "../routes/imagePathRoutes";
import ServerURL from "../server/serverUrl";
import SuccessModal from "../components/sucessmodel";

const AddOfferPost = () => {
  const { id } = useParams();
  const [adminId, setAdminId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  const [isSuccessVisible, setIsSuccessVisible] = useState(false);
  const [webImage, setWebImage] = useState("");
  const [mobileImage, setMobileImage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [formData, setFormData] = useState({
    Imagepath: "",
    MobileImagepath: "",
    OfferDescription: "",
    OfferName: "",
  });


  const [istopoffer, setIsTopoffer] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const adminUserId = JSON.parse(localStorage.getItem("adminuserid"));
    if (!adminUserId) {
      alert("Session Closed. Please Login Again!");
      setTimeout(() => {
        navigate("/");
      }, 2000);
    } else {
      setAdminId(Number(adminUserId));
    }
  }, [navigate]);

  useEffect(() => {
    const areas = JSON.parse(localStorage.getItem("AdminOfferPost"));
    if (areas) {
      const areaData = areas.find((area) => area.Id === parseInt(id, 10));
      if (areaData) {
        const webImagePath = areaData.Imagepath ? areaData.Imagepath.replace("/offerposts/", "") : null;
        const mobileImagePath = areaData.MobileImagepath ? areaData.MobileImagepath.replace("/offerposts/", "") : null;
        setFormData({
          Imagepath: webImagePath || "",
          MobileImagepath: mobileImagePath || "",
          OfferDescription: areaData.OfferDescription || "",
          OfferName: areaData.OfferName || "",
        });
        setWebImage(webImagePath);
        setMobileImage(mobileImagePath);
      }
    }
  }, [id]);

  const closeErrorModal = () => {
    setIsErrorModalOpen(false);
  };

  const closeSuccessModal = () => {
    setIsSuccessVisible(false);
  };

  const handleImageUpload = async (e, type) => {
    const formData = new FormData();
    const file = e.target.files[0];
    if (file) {
      formData.append("MyImages", file);
      setLoading(true);

      try {
        const uploadImage = `${ServerURL.PRODUCTION_HOST_URL}api/OfferPost/UploadOfferPostFile`;
        const response = await fetch(uploadImage, {
          method: "POST",
          body: formData,
        });

        const data = await response.json();

        if (response.ok) {
          setIsSuccessVisible(true);
          setSuccessMessage("Image saved successfully!");
          if (type === "web") {
            setWebImage(data);
          } else {
            setMobileImage(data);
          }
        } else {
          setErrorMessage("Image upload failed!");
          setIsErrorModalOpen(true);
        }
      } catch (error) {
        console.error("Error uploading image:", error);
        setErrorMessage("An error occurred during the image upload.");
        setIsErrorModalOpen(true);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(true);

    const objlist = {
      Id: id ? parseInt(id) : "",
      Comid: adminId,
      OfferPer: 0,
      OfferName: formData.OfferName,
      OfferDescription: formData.OfferDescription,
      Imagepath: webImage,
      MobileImagepath: mobileImage,
      NewPostImagePath: "",
      OfferPostImagePath: "",
      SubCatPostImagePath: "",
      OfferSubDescription: formData.OfferName,
      istopoffer:istopoffer ? 1 : 0,
    };

    try {
      const success = await insertOfferPost([objlist]);
      if (success) {
        setIsSuccessVisible(true);
        setSuccessMessage("Offer Post saved successfully!");
        navigate(`/OfferPost`);
      } else {
        setErrorMessage("Failed to save the offer.");
        setIsErrorModalOpen(true);
      }
    } catch (error) {
      console.error("Error during offer post insertion:", error);
      setErrorMessage("An error occurred while saving the offer.");
      setIsErrorModalOpen(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex h-screen bg-gray-50">
      <div className="flex-shrink-0">
        <Slider />
      </div>

      <div className="flex-1 p-6 bg-white rounded-lg shadow-lg">
        <div className="container mx-auto max-w-full">
          <div className="card shadow-lg rounded-lg mb-8 bg-white p-9">
            <div className="card-header px-6 py-4 border-b">
              <h5 className="text-2xl font-semibold text-gray-800">Add Offer Post</h5>
            </div>

            <form className="space-y-6">
                <div>
                  <label className="block text-lg font-medium text-gray-700">Offer Name <span className="text-red-500">*</span></label>
                  <input
                    type="text"
                    value={formData.OfferName}
                    onChange={(e) =>
                      setFormData({ ...formData, OfferName: e.target.value })
                    }
                    className="block w-full mt-2 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 transition"
                    placeholder="Enter Offer Name"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700">Offer Description (optional)</label>
                  <textarea
                    value={formData.OfferDescription}
                    onChange={(e) =>
                      setFormData({ ...formData, OfferDescription: e.target.value })
                    }
                    className="block w-full mt-2 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 transition"
                    rows="4"
                    placeholder="Enter offer description"
                  />
                </div>

                {/* Image Upload Fields */}
                {/* Web Image */}
                <div>
                  <label className="block text-sm font-medium text-gray-700">Web Poster <span className="text-red-500">*</span></label>
                  <div className="mt-3">
                    <label htmlFor="Filewebimg" className="w-full cursor-pointer bg-blue-600 text-white px-4 py-2 rounded-md text-center hover:bg-blue-700 transition">
                      Browse
                    </label>
                    <input
                      type="file"
                      id="Filewebimg"
                      accept="image/x-png,image/gif,image/jpeg,image/svg"
                      onChange={(e) => handleImageUpload(e, "web")}
                      className="hidden"
                    />
                    <span className="text-gray-600">{webImage}</span>
                  </div>
                  <div className="mt-2">
                    <img
                      src={webImage ? (ImagePathRoutes.OfferprePostImagePath + webImage) : 'https://i.gifer.com/origin/e0/e0ea055299e92297b2ec0ef1c80696bf_w200.gif'}
                      alt="Web Image"
                      className="w-44 h-36 rounded-lg"
                    />
                  </div>
                </div>

                {/* Mobile Image */}
                <div>
                  <label className="block text-sm font-medium text-gray-700">Mobile Poster <span className="text-red-500">*</span></label>
                  <div className="mt-3">
                    <label htmlFor="Filemobileimg" className="w-full cursor-pointer bg-blue-600 text-white px-4 py-2 rounded-md text-center hover:bg-blue-700 transition">
                      Browse
                    </label>
                    <input
                      type="file"
                      id="Filemobileimg"
                      accept="image/x-png,image/gif,image/jpeg,image/svg"
                      onChange={(e) => handleImageUpload(e, "mobile")}
                      className="hidden"
                    />
                    <span className="text-gray-600">{mobileImage}</span>
                  </div>
                  <div className="mt-2">
                    <img
                      src={mobileImage ? (ImagePathRoutes.OfferprePostImagePath + mobileImage) : 'https://i.gifer.com/origin/e0/e0ea055299e92297b2ec0ef1c80696bf_w200.gif'}
                      alt="Mobile Image"
                      className="w-44 h-36 rounded-lg"
                    />
                  </div>
                </div>
            

                {/* Is Top Offer */}
                <div className="flex items-center gap-4">
                  <label className="text-sm font-medium text-gray-700">Is Top Offer</label>
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      checked={istopoffer}
                      onChange={() => setIsTopoffer(!istopoffer)}
                      className="form-checkbox h-5 w-5 text-blue-600 transition duration-200"
                    />
                    <span className="ml-2 text-sm text-gray-600">{istopoffer ? 'Yes' : 'No'}</span>
                  </div>
                </div>
                <div className="flex space-x-4 mt-6">
                  <button
                    onClick={handleSave}
                    disabled={loading}
                    className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    {loading ? "Saving..." : (id ? "Update Offer" : "Add Offer")}
                  </button>
                  <button
                    type="button"
                    className="px-6 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400 focus:outline-none"
                    onClick={() => {
                      setFormData({ ...formData, OfferName: "", OfferDescription: "" });
                      setWebImage("");
                      setMobileImage("");
                      setIsTopoffer(false);
                    }}
                  >
                    Clear
                  </button>
                   <button
                     type="button"
                     onClick={() => navigate("/OfferPost")}
                     className="px-6 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400 focus:outline-none"
                   >
                     Cancel
                   </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      

      {/* Error Modal */}
      {isErrorModalOpen && <ErrorModal message={errorMessage} onClose={closeErrorModal} />}

      {/* Success Modal */}
      {isSuccessVisible && <SuccessModal message={successMessage} onClose={closeSuccessModal} />}
    </div>
                  
  );
};

export default AddOfferPost;
